export default __webpack_public_path__ + "b53199dcf213cc3e312bb066ba14edb2.png";